import { getClosestValidDate } from '@blocks/utils';

export const correctTime = ([date], state, tools) => {
  const closestValidDate = getClosestValidDate(date);

  if (closestValidDate) {
    tools.changeValue(state, 'deadline_datetime', () => closestValidDate);
  }
};

export const setRecommendedDeadline = ([deadline_datetime], state, tools) => {
  tools.changeValue(state, 'deadline_datetime', () => deadline_datetime);
};

export const removeWriter = (args, state, { changeValue }) => {
  changeValue(state, 'writer_req_slug', () => '');
};

export const requestWriter = ([writer_req_slug], state, { changeValue }) => {
  if (writer_req_slug) {
    changeValue(state, 'writer_req_slug', () => writer_req_slug);
  }
};

export const applyDeadline = ([deadline_datetime], state, { changeValue }) => {
  if (deadline_datetime) {
    changeValue(state, 'deadline_datetime', () => deadline_datetime);
  }
};

export const applyTitle = ([title], state, { changeValue }) => {
  if (title) {
    changeValue(state, 'title', () => title);
  }
};

export const removeTitle = (args, state, { changeValue }) => {
  changeValue(state, 'title', () => '');
};

export const applyLogin = ([login], state, { changeValue }) => {
  if (login) {
    changeValue(state, 'login', () => login);
  }
};

/**
 * XXX common/oauth2 usedOAuth2Provider (disable modal with policies if usedOAuth2Provider exists)
 */
export const togglePolicy = ([policy_agree], state, { changeValue }) => {
  changeValue(state, 'policy_agree', () => policy_agree);
};
